import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ProfileDropdown from './ProfileDropdown';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const { currentUser } = useAuth();
  const ADMIN_UID = "qo7x9wiqlJThtRxqaKJ2AHst6Uf2";

  return (
    <header className="app-header">
      <nav className="header-nav">
        <div style={{ display: 'flex', gap: '32px' }}>
          <Link to="/home" className={location.pathname === '/home' ? 'active' : ''}>Home</Link>
          {currentUser?.uid === ADMIN_UID && (
            <Link to="/analytics" className={location.pathname === '/analytics' ? 'active' : ''}>Analytics</Link>
          )}
        </div>
        <ProfileDropdown />
      </nav>
    </header>
  );
};

export default Header;
